export default __webpack_public_path__ + "static/screen_ipad_progress-49ac202ea26445ad88b955483c7f2ced.png";